<template>
  <div>
    <div
      v-if="step > 0"
      class="wwi-header--steps"
    >
      {{ $t('components.common.pageHeader.steps', { step: step, totalSteps: totalSteps }) }}
    </div>
    <div class="wwi-header--title">
      {{ title }}
    </div>
    <div
      v-if="description"
      class="wwi-header--description"
    >
      {{ description }}
    </div>
    <div
      v-if="error"
      class="wwi-header--error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      default: 0,
      type: Number
    },
    title: {
      default: '',
      type: String
    },
    description: {
      default: null,
      type: String
    },
    error: {
      default: null,
      type: String
    }
  },
  data () {
    return {
      totalSteps: 4
    }
  }
}
</script>
